import React from 'react'
import ErrorPage from '../ErrorPage'
import DetailedHeader from '../UiComponents/DetailedHeader'
import NavigationColumn from '../UiComponents/NavigationColumn'
import { LOCAL_STORAGE_USER_KEY } from '../../../constants/app'

import './layout.css'
import '../css/Common.css'


const BaseLayout = (props) => {
    const { children, isErrorPage } = props;
    const user = localStorage.getItem(LOCAL_STORAGE_USER_KEY);

    return (
        <div>
            <DetailedHeader showProfile={props.showProfile} />
            <div className="row-flex">
                { user && <NavigationColumn userType={JSON.parse(user).potential_user_type}/> }
                { isErrorPage ? <ErrorPage is500Error={true} /> : children }
            </div>
        </div>
    )
}

export default BaseLayout;
